import { zetApi } from '@zet/network'

export type verifyPhoneNumberParams = {
  fullName: string | undefined
  phoneNumber: string | undefined
  otpLess?: boolean
}

export type resendOtpParams = {
  customerId?: number
  secondaryPhoneNumber?: string
  isApp: boolean
}

const verifyPhoneNumber = async ({
  fullName,
  phoneNumber,
  otpLess = false,
}: verifyPhoneNumberParams) => {
  const { data } = await zetApi.post(
    `customer/addCustomerOtp/v2?otpLess=${otpLess}`,
    {
      fullName,
      phoneNumber,
    }
  )

  if (data?.data) return data?.data
  else throw data?.error?.message
}

const resendOtpSecondaryPhoneNumber = async ({
  customerId,
  isApp,
  secondaryPhoneNumber,
}: resendOtpParams) => {
  const { data } = await zetApi.post(
    `customer/resendOtp/secondaryPhone?isApp=${isApp}`,
    {
      customerId,
      secondaryPhoneNumber,
    }
  )
  if (data?.data) return data?.data
  else throw data?.error?.message
}

export { resendOtpSecondaryPhoneNumber, verifyPhoneNumber }
